module.exports = __webpack_public_path__ + "static/media/sen.d0e1767b.pdf";